/*
 * @Date: 2020-08-28 15:57:18
 * @Author: MX
 * @LastEditTime: 2020-12-22 14:15:22
 * @Description: 校验规则
 */
import {lang} from "../utils/filters"


import { bus } from '../utils/common'

const RULESJson = function() {
  return {
    required: { message: lang('请输入'), required: true, trigger: ['blur', 'change'] },
    account: { required: true, message: lang('请输入账号'), trigger: ['blur', 'change'] }, //账号
    password: { required: true, message: lang('请输入密码'), trigger: ['blur', 'change'] }, //密码
    phone: { required: true, message: lang('请输入手机号'), trigger: ['blur', 'change'] },  //手机号
    checkPassword: { validator: checkPassword, trigger: ['blur', 'change'] }, // 校验密码
    passwordNew:{validator: passwordNew, trigger: ['blur', 'change'] },
    checkPhone: {  validator: checkPhone, trigger: ['blur', 'change'] }, // 校验手机号
    captcha: { required: true, message: lang('请输入图形验证码'), trigger: ['blur', 'change'] },//请输入验证码
    phoneCode: { required: true, message: lang('请输入手机验证码'), trigger: ['blur', 'change'] },
    checkIdCard: { validator: checkIdCard, trigger: ['blur', 'change'] },//校验身份证
    url:{validator:urlValidation,trigger: ['blur', 'change']},//校验url
    email: { validator: email, trigger: ['blur', 'change'] }, // 邮箱
    noBlankSpace: { validator: noBlankSpace, trigger: ['blur', 'change'] }
  }
}
export let RULES = RULESJson()
bus.$on('langJsonChange', () => {
  Object.assign(RULES,RULESJson())
})


//验证身份证
export function checkIdCard (rule, value, callback) {
    if (value && !(VALIDATION.checkIdCard.value.test(value) && (/\d/).test(value))) {
        callback(new Error(lang(VALIDATION.checkIdCard.label)))
    } else {
        callback()
    }
}


// 验证密码
export function checkPassword (rule, value, callback) {
    if (value && !(VALIDATION.checkPassword.value.test(value) && (/\d/).test(value))) {
        callback(new Error(lang(VALIDATION.checkPassword.label)))
    } else {
        callback()
    }
}
// 校验手机号不能超过11位，且为数字 
export function checkPhone (rule, value, callback) {
    if (value && !VALIDATION.phoneNumber.value.test(value)) {
        callback(new Error(lang(VALIDATION.phoneNumber.label)))
    } else {
        callback()
    }
}
// 验证密码 新
export function passwordNew (rule, value, callback) {
    if (value && !VALIDATION.passwordNew.value.test(value)) {
        callback(new Error(lang(VALIDATION.passwordNew.label)))
    } else {
        callback()
    }
}
// url校验 新
export function urlValidation (rule, value, callback) {
    if (value && !VALIDATION.url.value.test(value)) {
        callback(new Error(lang(VALIDATION.url.label)))
    } else {
        callback()
    }
}
// 可空 email 邮箱格式校验
export function email(rule, value, callback) {
  if (value && !VALIDATION.email.value.test(value)) {
    callback(new Error(lang(VALIDATION.email.label)))
  } else {
    callback()
  }
}
// 不能有空格
export function noBlankSpace(rule, value, callback) {
  if (!VALIDATION.noBlankSpace.value.test(value)) {
    callback(new Error(lang(VALIDATION.noBlankSpace.label)))
  } else {
    callback()
  }
}
/* eslint-disable  */
export const VALIDATION = {
    'phoneNumber': {
        'value': /^[0-9]*$/,
        'label': '输入的手机号码格式不正确',
    },
    'checkPassword': {
        'value': /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z\\W_!@#$%^&*`~()-+=]{6,18}$/,
        'label': '请输入6-18位之间，大写字母、小写字母、数字和特殊字符',
    },
    "checkIdCard": {
        // 'value': /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
        value:/^[0-9a-zA-Z]*$/,
        'label': '请输入正确的居民身份证',
    },
    // 密码校验 新
    'passwordNew': {
        label: '大写字母、小写字母、数字和特殊字符4选3,长度6-18',
        value: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\\W_!@#$%^&*`~()-+=]+$)(?![0-9\\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\\W_!@#$%^&*`~()-+=]{6,18}$/
      },
      url: {
          label:"请输入以http/https为开头的url",
          value: /^(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?$/i,
        //   value:/http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/,
      },
      email: {
        label: '请输入正确的邮箱账号',
        value: /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i
      },
      noBlankSpace: {
        value: /^\S*$/,
        label: '请勿输入空格'
      }
      
}
